import type { RootState } from "~/app/store";

export const selectNavigationNodes = (state: RootState) => {
  return state.navigation.categoryNavigation.nodes;
};

export const selectRootNode = (state: RootState) => {
  return state.navigation.categoryNavigation.root;
};
